import * as local from './_local'
import * as gateway from './_gateway'

export const api = {
    local, 
    gateway
}